/* @flow */
import createDebugger from 'debug';
import { prop, propOr } from 'ramda';
import { combineEpics, ofType } from 'redux-observable';
import {Observable}from 'rxjs';
import { catchError, map, mapTo, mergeMap, startWith, switchMap } from 'rxjs/operators';

import { TRIAGE_ENDPOINT } from 'modules/triage/constants';

import { success, error } from '../alerts/actions';
import {
  FETCH_METADATA_SUCCESS as FETCH_REPORT_METADATA_SUCCESS,
} from '../reports/action-types';
import * as ReportActionsCreator from '../reports/actions'

import {
  SET_TRIAGE_STATUS_FOR_REPORT,
  FETCH_TRIAGE_REPORTS,
  FETCH_TRIAGE_REPORTS_AND_ENRICH,
  SET_TRIAGE_STATUS_FOR_REPORT_FAILURE,
  SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS,
} from './action-types';
import * as TriageReportActionsCreator from './actions';

const debug = createDebugger('app:modules:triage:epics'); // eslint-disable-line no-unused-vars

const setTriageStatusEpic = (action$, store, {ajax}) =>
  action$.ofType(SET_TRIAGE_STATUS_FOR_REPORT)
    .mergeMap(({payload}) => {
      return ajax.post(`${TRIAGE_ENDPOINT}/${payload.submissionId}/status?status=${payload.status}`)
        .mergeMap(response => {
          return [
            {type: SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS, payload},
            success(`Submission status set to ${payload.status}`),
          ];
        })
        .catch(err => {
          return [
            {type: SET_TRIAGE_STATUS_FOR_REPORT_FAILURE}, // TODO Error Handling
            error('An error occurred and the submission status could be updated'),
          ];
        });
    });

const fetchEnrichedTriageReportsEpic = (action$, _, { ajax }) => action$.pipe(
  ofType(FETCH_TRIAGE_REPORTS_AND_ENRICH),
  switchMap((action) => ajax.postJSON(TRIAGE_ENDPOINT, action.payload)
    .map(prop('response'))
    .switchMap((response) => {
      const reportIds = response.items.map(propOr('', 'submissionId'));

      return Observable.if(
        () => reportIds.length > 0,
        action$.pipe(
          ofType(FETCH_REPORT_METADATA_SUCCESS),
          mapTo(TriageReportActionsCreator.fetchTriageReportsSuccess(response)),
          startWith(ReportActionsCreator.fetchReportMetadata(reportIds, true)),
        ),
        Observable.of(TriageReportActionsCreator.fetchTriageReportsSuccess(response)),
      );
    })
    .catch((error) => Observable.of(TriageReportActionsCreator.fetchTriageReportsFailure(error)))
  ),
);

const fetchTriageReportsEpic = (action$, _, {ajax}) =>
  action$.ofType(FETCH_TRIAGE_REPORTS)
    .mergeMap(({ payload }) => {
      return ajax.postJSON(TRIAGE_ENDPOINT, payload)
        .map(prop('response'))
        .map((response) => TriageReportActionsCreator.fetchTriageReportsSuccess(response))
        .catch((error) => TriageReportActionsCreator.fetchTriageReportsFailure(error))
    });

export default combineEpics(
  setTriageStatusEpic,
  fetchTriageReportsEpic,
  fetchEnrichedTriageReportsEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/triage/epics.js